<template>
    <div class="overview" v-if="interests.length > 0">
        <div :key="interest.id" v-for="interest in interests"
             class="overview__item overview__item--condensed show-control">
            <p class="overview__title">
                {{ interest.createdAt | dateFormat }}
            </p>
            <p class="overview__description" v-if="interest.message">
                {{ interest.message }}
            </p>
            <p class="overview__description">
                <span class="overview__partials" v-if="interest.unit">
                    Jednotka
                    <router-link :to="{ name: 'project-unit-detail', params: {unitId: interest.unit.id}}"
                                 class="text--maroon">
                        {{ interest.unit.designation }}
                    </router-link>
                </span>
                <span class="overview__partials" v-if="interest.phone">
                    Telefon <strong class="text--info">{{ interest.phone }}</strong>
                </span>
                <span class="overview__partials" v-if="interest.email">
                    E-mail <strong class="text--info">{{ interest.email }}</strong>
                </span>
            </p>
            <div class="overview__controls z1">
                <!--<custom-button @click="update(interest.id)" iconic>
                    <span icon edit></span>Upravit
                </custom-button>-->
                <custom-button @click="remove(interest)" iconic class="visible-on-overview-hover">
                    <span icon remove></span>Odstranit
                </custom-button>
            </div>
        </div>
    </div>
</template>

<script>
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'InterestList',
    components: {CustomButton},
    computed:   {
        interests() {
            return this.$store.getters['projects/project/customer/interest/interests'];
        }
    },
    methods:    {
        remove(interest) {
            const {id} = interest;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete zájemce odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/customer/interest/removeInterest', id)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        },
    }
}
</script>
